import Styled from 'styled-components'

const Estilo = Styled.div`
    margin: 0;
    padding: 0;

    
`

export default Estilo